import React from 'react';
import { motion } from "framer-motion";
import { LayoutDashboard, Newspaper, MessageSquare, Cookie, Mail, IterationCw, Database, FileBarChart, CalendarDays, ShieldCheck, FileText,SquareUserRound } from 'lucide-react';

const menuItems = [
    { name: 'Dashboard', icon: <LayoutDashboard size={50} className="text-green-400" /> },
    { name: 'Media Update', icon: <Newspaper size={50} className="text-green-400" /> },
    { name: 'Events Update', icon: <CalendarDays size={50} className="text-green-400" /> },
    { name: 'Compliance Update', icon: <ShieldCheck size={50} className="text-green-400" /> },
    { name: 'Product Update', icon: <IterationCw size={50} className="text-green-400" /> },
    { name: 'PDF Update', icon: <FileText size={50} className="text-green-400" /> },
    { name: 'Related Document', icon: <FileBarChart size={50} className="text-green-400" /> },
    { name: 'Update Group', icon: <MessageSquare size={50} className="text-green-400" /> },
    { name: 'Update Mail', icon: <Mail size={50} className="text-green-400" /> },
    { name: 'ON/OFF Cookies', icon: <Cookie size={50} className="text-green-400" /> },
    { name: 'Cookies Data', icon: <Database  size={50} className="text-green-500" /> },
    { name: 'Admin Registration', icon: <SquareUserRound  size={50} className="text-green-500" /> },

];

function DashboardTwo({ onSelect }) {
    return (
        <div className="flex flex-col items-center justify-center px-0 py-6 rounded-lg bg-gray-700 min-h-screen">
            {/* Header */}
            {/* <h1 className="text-4xl font-bold text-white mb-5 tracking-wide drop-shadow-lg">
                Dashboard
            </h1> */}
            <motion.h2
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="text-3xl font-bold text-gray-900 bg-clip-text text-center mb-4 text-transparent bg-gradient-to-r from-blue-500 to-purple-500"
            >
                Dashboard
            </motion.h2>
            

            {/* Card Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
                {menuItems.map((item, index) => (
                    <div
                        key={index}
                        className="relative flex flex-col items-center justify-center w-52 h-52 bg-gray-900 bg-opacity-40 border border-gray-700 rounded-3xl shadow-lg backdrop-blur-lg transition-transform transform hover:scale-105 hover:border-blue-500 hover:shadow-blue-500/50 cursor-pointer"
                        onClick={() => onSelect(item.name)}
                    >
                        {/* Icon with Glow */}
                        <div className="p-4 bg-gray-800 rounded-full shadow-[0px_0px_5px_5px_rgba(59,130,246,0.5)]">
                            {item.icon}
                        </div>


                        {/* Title */}
                        <span className="mt-4 text-xl font-semibold text-white">{item.name}</span>

                        {/* Glow Effect */}
                        <div className="absolute inset-0 bg-blue-500/10 rounded-3xl opacity-0 transition-opacity duration-300 hover:opacity-100"></div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DashboardTwo;
